import * as ActionType from '../../constants/actionType';

const initialState = {
  selectedTip: {
    1: [
      // { col: 0, row: 0 },
      // { col: 1, row: 0 },
      // { col: 2, row: 0 },
      // { col: 3, row: 0 },
      // { col: 4, row: 0 },
      // { col: 5, row: 0 },
      // { col: 6, row: 0 },
      // { col: 7, row: 0 },
      // { col: 8, row: 0 },
      // { col: 9, row: 0 },
      // { col: 10, row: 0 },
      // { col: 11, row: 0 },
      // { col: 12, row: 0 },
      // { col: 13, row: 0 },
      // { col: 14, row: 0 },
      // { col: 15, row: 0 },
      // { col: 16, row: 0 },
      // { col: 17, row: 0 },
      // { col: 18, row: 0 },
      // { col: 19, row: 0 },
      // { col: 20, row: 0 },
      // { col: 21, row: 0 },
      // { col: 22, row: 0 },
      // { col: 23, row: 0 },
      // { col: 0, row: 1 },
      // { col: 1, row: 1 },
      // { col: 2, row: 1 },
      // { col: 3, row: 1 },
      // { col: 4, row: 1 },
      // { col: 5, row: 1 },
      // { col: 6, row: 1 },
      // { col: 7, row: 1 },
      // { col: 8, row: 1 },
      // { col: 9, row: 1 },
      // { col: 10, row: 1 },
      // { col: 11, row: 1 },
      // { col: 12, row: 1 },
      // { col: 13, row: 1 },
      // { col: 14, row: 1 },
      // { col: 15, row: 1 },
      // { col: 16, row: 1 },
      // { col: 17, row: 1 },
      // { col: 18, row: 1 },
      // { col: 19, row: 1 },
      // { col: 20, row: 1 },
      // { col: 21, row: 1 },
      // { col: 22, row: 1 },
      // { col: 23, row: 1 },
      // { col: 0, row: 2 },
      // { col: 1, row: 2 },
      // { col: 2, row: 2 },
      // { col: 3, row: 2 },
      // { col: 4, row: 2 },
      // { col: 5, row: 2 },
      // { col: 6, row: 2 },
      // { col: 7, row: 2 },
      // { col: 8, row: 2 },
      // { col: 9, row: 2 },
      // { col: 10, row: 2 },
      // { col: 11, row: 2 },
      // { col: 12, row: 2 },
      // { col: 13, row: 2 },
      // { col: 14, row: 2 },
      // { col: 15, row: 2 },
      // { col: 16, row: 2 },
      // { col: 17, row: 2 },
      // { col: 18, row: 2 },
      // { col: 19, row: 2 },
      // { col: 20, row: 2 },
      // { col: 21, row: 2 },
      // { col: 22, row: 2 },
      // { col: 23, row: 2 },
      // { col: 0, row: 3 },
      // { col: 1, row: 3 },
      // { col: 2, row: 3 },
      // { col: 3, row: 3 },
      // { col: 4, row: 3 },
      // { col: 5, row: 3 },
      // { col: 6, row: 3 },
      // { col: 7, row: 3 },
      // { col: 8, row: 3 },
      // { col: 9, row: 3 },
      // { col: 10, row: 3 },
      // { col: 11, row: 3 },
      // { col: 12, row: 3 },
      // { col: 13, row: 3 },
      // { col: 14, row: 3 },
      // { col: 15, row: 3 },
      // { col: 16, row: 3 },
      // { col: 17, row: 3 },
      // { col: 18, row: 3 },
      // { col: 19, row: 3 },
      // { col: 20, row: 3 },
      // { col: 21, row: 3 },
      // { col: 22, row: 3 },
      // { col: 23, row: 3 },
      // { col: 0, row: 4 },
      // { col: 1, row: 4 },
      // { col: 2, row: 4 },
      // { col: 3, row: 4 },
      // { col: 4, row: 4 },
      // { col: 5, row: 4 },
      // { col: 6, row: 4 },
      // { col: 7, row: 4 },
      // { col: 8, row: 4 },
      // { col: 9, row: 4 },
      // { col: 10, row: 4 },
      // { col: 11, row: 4 },
      // { col: 12, row: 4 },
      // { col: 13, row: 4 },
      // { col: 14, row: 4 },
      // { col: 15, row: 4 },
      // { col: 16, row: 4 },
      // { col: 17, row: 4 },
      // { col: 18, row: 4 },
      // { col: 19, row: 4 },
      // { col: 20, row: 4 },
      // { col: 21, row: 4 },
      // { col: 22, row: 4 },
      // { col: 23, row: 4 },
      // { col: 0, row: 5 },
      // { col: 1, row: 5 },
      // { col: 2, row: 5 },
      // { col: 3, row: 5 },
      // { col: 4, row: 5 },
      // { col: 5, row: 5 },
      // { col: 6, row: 5 },
      // { col: 7, row: 5 },
      // { col: 8, row: 5 },
      // { col: 9, row: 5 },
      // { col: 10, row: 5 },
      // { col: 11, row: 5 },
      // { col: 12, row: 5 },
      // { col: 13, row: 5 },
      // { col: 14, row: 5 },
      // { col: 15, row: 5 },
      // { col: 16, row: 5 },
      // { col: 17, row: 5 },
      // { col: 18, row: 5 },
      // { col: 19, row: 5 },
      // { col: 20, row: 5 },
      // { col: 21, row: 5 },
      // { col: 22, row: 5 },
      // { col: 23, row: 5 },
      // { col: 0, row: 6 },
      // { col: 1, row: 6 },
      // { col: 2, row: 6 },
      // { col: 3, row: 6 },
      // { col: 4, row: 6 },
      // { col: 5, row: 6 },
      // { col: 6, row: 6 },
      // { col: 7, row: 6 },
      // { col: 8, row: 6 },
      // { col: 9, row: 6 },
      // { col: 10, row: 6 },
      // { col: 11, row: 6 },
      // { col: 12, row: 6 },
      // { col: 13, row: 6 },
      // { col: 14, row: 6 },
      // { col: 15, row: 6 },
      // { col: 16, row: 6 },
      // { col: 17, row: 6 },
      // { col: 18, row: 6 },
      // { col: 19, row: 6 },
      // { col: 20, row: 6 },
      // { col: 21, row: 6 },
      // { col: 22, row: 6 },
      // { col: 23, row: 6 },
      // { col: 0, row: 7 },
      // { col: 1, row: 7 },
      // { col: 2, row: 7 },
      // { col: 3, row: 7 },
      // { col: 4, row: 7 },
      // { col: 5, row: 7 },
      // { col: 6, row: 7 },
      // { col: 7, row: 7 },
      // { col: 8, row: 7 },
      // { col: 9, row: 7 },
      // { col: 10, row: 7 },
      // { col: 11, row: 7 },
      // { col: 12, row: 7 },
      // { col: 13, row: 7 },
      // { col: 14, row: 7 },
      // { col: 15, row: 7 },
      // { col: 16, row: 7 },
      // { col: 17, row: 7 },
      // { col: 18, row: 7 },
      // { col: 19, row: 7 },
      // { col: 20, row: 7 },
      // { col: 21, row: 7 },
      // { col: 22, row: 7 },
      // { col: 23, row: 7 },
      // { col: 0, row: 8 },
      // { col: 1, row: 8 },
      // { col: 2, row: 8 },
      // { col: 3, row: 8 },
      // { col: 4, row: 8 },
      // { col: 5, row: 8 },
      // { col: 6, row: 8 },
      // { col: 7, row: 8 },
      // { col: 8, row: 8 },
      // { col: 9, row: 8 },
      // { col: 10, row: 8 },
      // { col: 11, row: 8 },
      // { col: 12, row: 8 },
      // { col: 13, row: 8 },
      // { col: 14, row: 8 },
      // { col: 15, row: 8 },
      // { col: 16, row: 8 },
      // { col: 17, row: 8 },
      // { col: 18, row: 8 },
      // { col: 19, row: 8 },
      // { col: 20, row: 8 },
      // { col: 21, row: 8 },
      // { col: 22, row: 8 },
      // { col: 23, row: 8 },
      // { col: 0, row: 9 },
      // { col: 1, row: 9 },
      // { col: 2, row: 9 },
      // { col: 3, row: 9 },
      // { col: 4, row: 9 },
      // { col: 5, row: 9 },
      // { col: 6, row: 9 },
      // { col: 7, row: 9 },
      // { col: 8, row: 9 },
      // { col: 9, row: 9 },
      // { col: 10, row: 9 },
      // { col: 11, row: 9 },
      // { col: 12, row: 9 },
      // { col: 13, row: 9 },
      // { col: 14, row: 9 },
      // { col: 15, row: 9 },
      // { col: 16, row: 9 },
      // { col: 17, row: 9 },
      // { col: 18, row: 9 },
      // { col: 19, row: 9 },
      // { col: 20, row: 9 },
      // { col: 21, row: 9 },
      // { col: 22, row: 9 },
      // { col: 23, row: 9 },
      // { col: 0, row: 10 },
      // { col: 1, row: 10 },
      // { col: 2, row: 10 },
      // { col: 3, row: 10 },
      // { col: 4, row: 10 },
      // { col: 5, row: 10 },
      // { col: 6, row: 10 },
      // { col: 7, row: 10 },
      // { col: 8, row: 10 },
      // { col: 9, row: 10 },
      // { col: 10, row: 10 },
      // { col: 11, row: 10 },
      // { col: 12, row: 10 },
      // { col: 13, row: 10 },
      // { col: 14, row: 10 },
      // { col: 15, row: 10 },
      // { col: 16, row: 10 },
      // { col: 17, row: 10 },
      // { col: 18, row: 10 },
      // { col: 19, row: 10 },
      // { col: 20, row: 10 },
      // { col: 21, row: 10 },
      // { col: 22, row: 10 },
      // { col: 23, row: 10 },
      // { col: 0, row: 11 },
      // { col: 1, row: 11 },
      // { col: 2, row: 11 },
      // { col: 3, row: 11 },
      // { col: 4, row: 11 },
      // { col: 5, row: 11 },
      // { col: 6, row: 11 },
      // { col: 7, row: 11 },
      // { col: 8, row: 11 },
      // { col: 9, row: 11 },
      // { col: 10, row: 11 },
      // { col: 11, row: 11 },
      // { col: 12, row: 11 },
      // { col: 13, row: 11 },
      // { col: 14, row: 11 },
      // { col: 15, row: 11 },
      // { col: 16, row: 11 },
      // { col: 17, row: 11 },
      // { col: 18, row: 11 },
      // { col: 19, row: 11 },
      // { col: 20, row: 11 },
      // { col: 21, row: 11 },
      // { col: 22, row: 11 },
      // { col: 23, row: 11 },
      // { col: 0, row: 12 },
      // { col: 1, row: 12 },
      // { col: 2, row: 12 },
      // { col: 3, row: 12 },
      // { col: 4, row: 12 },
      // { col: 5, row: 12 },
      // { col: 6, row: 12 },
      // { col: 7, row: 12 },
      // { col: 8, row: 12 },
      // { col: 9, row: 12 },
      // { col: 10, row: 12 },
      // { col: 11, row: 12 },
      // { col: 12, row: 12 },
      // { col: 13, row: 12 },
      // { col: 14, row: 12 },
      // { col: 15, row: 12 },
      // { col: 16, row: 12 },
      // { col: 17, row: 12 },
      // { col: 18, row: 12 },
      // { col: 19, row: 12 },
      // { col: 20, row: 12 },
      // { col: 21, row: 12 },
      // { col: 22, row: 12 },
      // { col: 23, row: 12 },
      // { col: 0, row: 13 },
      // { col: 1, row: 13 },
      // { col: 2, row: 13 },
      // { col: 3, row: 13 },
      // { col: 4, row: 13 },
      // { col: 5, row: 13 },
      // { col: 6, row: 13 },
      // { col: 7, row: 13 },
      // { col: 8, row: 13 },
      // { col: 9, row: 13 },
      // { col: 10, row: 13 },
      // { col: 11, row: 13 },
      // { col: 12, row: 13 },
      // { col: 13, row: 13 },
      // { col: 14, row: 13 },
      // { col: 15, row: 13 },
      // { col: 16, row: 13 },
      // { col: 17, row: 13 },
      // { col: 18, row: 13 },
      // { col: 19, row: 13 },
      // { col: 20, row: 13 },
      // { col: 21, row: 13 },
      // { col: 22, row: 13 },
      // { col: 23, row: 13 },
      // { col: 0, row: 14 },
      // { col: 1, row: 14 },
      // { col: 2, row: 14 },
      // { col: 3, row: 14 },
      // { col: 4, row: 14 },
      // { col: 5, row: 14 },
      // { col: 6, row: 14 },
      // { col: 7, row: 14 },
      // { col: 8, row: 14 },
      // { col: 9, row: 14 },
      // { col: 10, row: 14 },
      // { col: 11, row: 14 },
      // { col: 12, row: 14 },
      // { col: 13, row: 14 },
      // { col: 14, row: 14 },
      // { col: 15, row: 14 },
      // { col: 16, row: 14 },
      // { col: 17, row: 14 },
      // { col: 18, row: 14 },
      // { col: 19, row: 14 },
      // { col: 20, row: 14 },
      // { col: 21, row: 14 },
      // { col: 22, row: 14 },
      // { col: 23, row: 14 },
      // { col: 0, row: 15 },
      // { col: 1, row: 15 },
      // { col: 2, row: 15 },
      // { col: 3, row: 15 },
      // { col: 4, row: 15 },
      // { col: 5, row: 15 },
      // { col: 6, row: 15 },
      // { col: 7, row: 15 },
      // { col: 8, row: 15 },
      // { col: 9, row: 15 },
      // { col: 10, row: 15 },
      // { col: 11, row: 15 },
      // { col: 12, row: 15 },
      // { col: 13, row: 15 },
      // { col: 14, row: 15 },
      // { col: 15, row: 15 },
      // { col: 16, row: 15 },
      // { col: 17, row: 15 },
      // { col: 18, row: 15 },
      // { col: 19, row: 15 },
      // { col: 20, row: 15 },
      // { col: 21, row: 15 },
      // { col: 22, row: 15 },
      // { col: 23, row: 15 },
    ],
    2: [],
  },
  prevSelectedTip: [
    // { col: 0, row: 0 },
    // { col: 1, row: 0 },
    // { col: 2, row: 0 },
    // { col: 3, row: 0 },
    // { col: 4, row: 0 },
    // { col: 5, row: 0 },
    // { col: 6, row: 0 },
    // { col: 7, row: 0 },
    // { col: 8, row: 0 },
    // { col: 9, row: 0 },
    // { col: 10, row: 0 },
    // { col: 11, row: 0 },
    // { col: 12, row: 0 },
    // { col: 13, row: 0 },
    // { col: 14, row: 0 },
    // { col: 15, row: 0 },
    // { col: 16, row: 0 },
    // { col: 17, row: 0 },
    // { col: 18, row: 0 },
    // { col: 19, row: 0 },
    // { col: 20, row: 0 },
    // { col: 21, row: 0 },
    // { col: 22, row: 0 },
    // { col: 23, row: 0 },
    // { col: 0, row: 1 },
    // { col: 1, row: 1 },
    // { col: 2, row: 1 },
    // { col: 3, row: 1 },
    // { col: 4, row: 1 },
    // { col: 5, row: 1 },
    // { col: 6, row: 1 },
    // { col: 7, row: 1 },
    // { col: 8, row: 1 },
    // { col: 9, row: 1 },
    // { col: 10, row: 1 },
    // { col: 11, row: 1 },
    // { col: 12, row: 1 },
    // { col: 13, row: 1 },
    // { col: 14, row: 1 },
    // { col: 15, row: 1 },
    // { col: 16, row: 1 },
    // { col: 17, row: 1 },
    // { col: 18, row: 1 },
    // { col: 19, row: 1 },
    // { col: 20, row: 1 },
    // { col: 21, row: 1 },
    // { col: 22, row: 1 },
    // { col: 23, row: 1 },
    // { col: 0, row: 2 },
    // { col: 1, row: 2 },
    // { col: 2, row: 2 },
    // { col: 3, row: 2 },
    // { col: 4, row: 2 },
    // { col: 5, row: 2 },
    // { col: 6, row: 2 },
    // { col: 7, row: 2 },
    // { col: 8, row: 2 },
    // { col: 9, row: 2 },
    // { col: 10, row: 2 },
    // { col: 11, row: 2 },
    // { col: 12, row: 2 },
    // { col: 13, row: 2 },
    // { col: 14, row: 2 },
    // { col: 15, row: 2 },
    // { col: 16, row: 2 },
    // { col: 17, row: 2 },
    // { col: 18, row: 2 },
    // { col: 19, row: 2 },
    // { col: 20, row: 2 },
    // { col: 21, row: 2 },
    // { col: 22, row: 2 },
    // { col: 23, row: 2 },
    // { col: 0, row: 3 },
    // { col: 1, row: 3 },
    // { col: 2, row: 3 },
    // { col: 3, row: 3 },
    // { col: 4, row: 3 },
    // { col: 5, row: 3 },
    // { col: 6, row: 3 },
    // { col: 7, row: 3 },
    // { col: 8, row: 3 },
    // { col: 9, row: 3 },
    // { col: 10, row: 3 },
    // { col: 11, row: 3 },
    // { col: 12, row: 3 },
    // { col: 13, row: 3 },
    // { col: 14, row: 3 },
    // { col: 15, row: 3 },
    // { col: 16, row: 3 },
    // { col: 17, row: 3 },
    // { col: 18, row: 3 },
    // { col: 19, row: 3 },
    // { col: 20, row: 3 },
    // { col: 21, row: 3 },
    // { col: 22, row: 3 },
    // { col: 23, row: 3 },
    // { col: 0, row: 4 },
    // { col: 1, row: 4 },
    // { col: 2, row: 4 },
    // { col: 3, row: 4 },
    // { col: 4, row: 4 },
    // { col: 5, row: 4 },
    // { col: 6, row: 4 },
    // { col: 7, row: 4 },
    // { col: 8, row: 4 },
    // { col: 9, row: 4 },
    // { col: 10, row: 4 },
    // { col: 11, row: 4 },
    // { col: 12, row: 4 },
    // { col: 13, row: 4 },
    // { col: 14, row: 4 },
    // { col: 15, row: 4 },
    // { col: 16, row: 4 },
    // { col: 17, row: 4 },
    // { col: 18, row: 4 },
    // { col: 19, row: 4 },
    // { col: 20, row: 4 },
    // { col: 21, row: 4 },
    // { col: 22, row: 4 },
    // { col: 23, row: 4 },
    // { col: 0, row: 5 },
    // { col: 1, row: 5 },
    // { col: 2, row: 5 },
    // { col: 3, row: 5 },
    // { col: 4, row: 5 },
    // { col: 5, row: 5 },
    // { col: 6, row: 5 },
    // { col: 7, row: 5 },
    // { col: 8, row: 5 },
    // { col: 9, row: 5 },
    // { col: 10, row: 5 },
    // { col: 11, row: 5 },
    // { col: 12, row: 5 },
    // { col: 13, row: 5 },
    // { col: 14, row: 5 },
    // { col: 15, row: 5 },
    // { col: 16, row: 5 },
    // { col: 17, row: 5 },
    // { col: 18, row: 5 },
    // { col: 19, row: 5 },
    // { col: 20, row: 5 },
    // { col: 21, row: 5 },
    // { col: 22, row: 5 },
    // { col: 23, row: 5 },
    // { col: 0, row: 6 },
    // { col: 1, row: 6 },
    // { col: 2, row: 6 },
    // { col: 3, row: 6 },
    // { col: 4, row: 6 },
    // { col: 5, row: 6 },
    // { col: 6, row: 6 },
    // { col: 7, row: 6 },
    // { col: 8, row: 6 },
    // { col: 9, row: 6 },
    // { col: 10, row: 6 },
    // { col: 11, row: 6 },
    // { col: 12, row: 6 },
    // { col: 13, row: 6 },
    // { col: 14, row: 6 },
    // { col: 15, row: 6 },
    // { col: 16, row: 6 },
    // { col: 17, row: 6 },
    // { col: 18, row: 6 },
    // { col: 19, row: 6 },
    // { col: 20, row: 6 },
    // { col: 21, row: 6 },
    // { col: 22, row: 6 },
    // { col: 23, row: 6 },
    // { col: 0, row: 7 },
    // { col: 1, row: 7 },
    // { col: 2, row: 7 },
    // { col: 3, row: 7 },
    // { col: 4, row: 7 },
    // { col: 5, row: 7 },
    // { col: 6, row: 7 },
    // { col: 7, row: 7 },
    // { col: 8, row: 7 },
    // { col: 9, row: 7 },
    // { col: 10, row: 7 },
    // { col: 11, row: 7 },
    // { col: 12, row: 7 },
    // { col: 13, row: 7 },
    // { col: 14, row: 7 },
    // { col: 15, row: 7 },
    // { col: 16, row: 7 },
    // { col: 17, row: 7 },
    // { col: 18, row: 7 },
    // { col: 19, row: 7 },
    // { col: 20, row: 7 },
    // { col: 21, row: 7 },
    // { col: 22, row: 7 },
    // { col: 23, row: 7 },
    // { col: 0, row: 8 },
    // { col: 1, row: 8 },
    // { col: 2, row: 8 },
    // { col: 3, row: 8 },
    // { col: 4, row: 8 },
    // { col: 5, row: 8 },
    // { col: 6, row: 8 },
    // { col: 7, row: 8 },
    // { col: 8, row: 8 },
    // { col: 9, row: 8 },
    // { col: 10, row: 8 },
    // { col: 11, row: 8 },
    // { col: 12, row: 8 },
    // { col: 13, row: 8 },
    // { col: 14, row: 8 },
    // { col: 15, row: 8 },
    // { col: 16, row: 8 },
    // { col: 17, row: 8 },
    // { col: 18, row: 8 },
    // { col: 19, row: 8 },
    // { col: 20, row: 8 },
    // { col: 21, row: 8 },
    // { col: 22, row: 8 },
    // { col: 23, row: 8 },
    // { col: 0, row: 9 },
    // { col: 1, row: 9 },
    // { col: 2, row: 9 },
    // { col: 3, row: 9 },
    // { col: 4, row: 9 },
    // { col: 5, row: 9 },
    // { col: 6, row: 9 },
    // { col: 7, row: 9 },
    // { col: 8, row: 9 },
    // { col: 9, row: 9 },
    // { col: 10, row: 9 },
    // { col: 11, row: 9 },
    // { col: 12, row: 9 },
    // { col: 13, row: 9 },
    // { col: 14, row: 9 },
    // { col: 15, row: 9 },
    // { col: 16, row: 9 },
    // { col: 17, row: 9 },
    // { col: 18, row: 9 },
    // { col: 19, row: 9 },
    // { col: 20, row: 9 },
    // { col: 21, row: 9 },
    // { col: 22, row: 9 },
    // { col: 23, row: 9 },
    // { col: 0, row: 10 },
    // { col: 1, row: 10 },
    // { col: 2, row: 10 },
    // { col: 3, row: 10 },
    // { col: 4, row: 10 },
    // { col: 5, row: 10 },
    // { col: 6, row: 10 },
    // { col: 7, row: 10 },
    // { col: 8, row: 10 },
    // { col: 9, row: 10 },
    // { col: 10, row: 10 },
    // { col: 11, row: 10 },
    // { col: 12, row: 10 },
    // { col: 13, row: 10 },
    // { col: 14, row: 10 },
    // { col: 15, row: 10 },
    // { col: 16, row: 10 },
    // { col: 17, row: 10 },
    // { col: 18, row: 10 },
    // { col: 19, row: 10 },
    // { col: 20, row: 10 },
    // { col: 21, row: 10 },
    // { col: 22, row: 10 },
    // { col: 23, row: 10 },
    // { col: 0, row: 11 },
    // { col: 1, row: 11 },
    // { col: 2, row: 11 },
    // { col: 3, row: 11 },
    // { col: 4, row: 11 },
    // { col: 5, row: 11 },
    // { col: 6, row: 11 },
    // { col: 7, row: 11 },
    // { col: 8, row: 11 },
    // { col: 9, row: 11 },
    // { col: 10, row: 11 },
    // { col: 11, row: 11 },
    // { col: 12, row: 11 },
    // { col: 13, row: 11 },
    // { col: 14, row: 11 },
    // { col: 15, row: 11 },
    // { col: 16, row: 11 },
    // { col: 17, row: 11 },
    // { col: 18, row: 11 },
    // { col: 19, row: 11 },
    // { col: 20, row: 11 },
    // { col: 21, row: 11 },
    // { col: 22, row: 11 },
    // { col: 23, row: 11 },
    // { col: 0, row: 12 },
    // { col: 1, row: 12 },
    // { col: 2, row: 12 },
    // { col: 3, row: 12 },
    // { col: 4, row: 12 },
    // { col: 5, row: 12 },
    // { col: 6, row: 12 },
    // { col: 7, row: 12 },
    // { col: 8, row: 12 },
    // { col: 9, row: 12 },
    // { col: 10, row: 12 },
    // { col: 11, row: 12 },
    // { col: 12, row: 12 },
    // { col: 13, row: 12 },
    // { col: 14, row: 12 },
    // { col: 15, row: 12 },
    // { col: 16, row: 12 },
    // { col: 17, row: 12 },
    // { col: 18, row: 12 },
    // { col: 19, row: 12 },
    // { col: 20, row: 12 },
    // { col: 21, row: 12 },
    // { col: 22, row: 12 },
    // { col: 23, row: 12 },
    // { col: 0, row: 13 },
    // { col: 1, row: 13 },
    // { col: 2, row: 13 },
    // { col: 3, row: 13 },
    // { col: 4, row: 13 },
    // { col: 5, row: 13 },
    // { col: 6, row: 13 },
    // { col: 7, row: 13 },
    // { col: 8, row: 13 },
    // { col: 9, row: 13 },
    // { col: 10, row: 13 },
    // { col: 11, row: 13 },
    // { col: 12, row: 13 },
    // { col: 13, row: 13 },
    // { col: 14, row: 13 },
    // { col: 15, row: 13 },
    // { col: 16, row: 13 },
    // { col: 17, row: 13 },
    // { col: 18, row: 13 },
    // { col: 19, row: 13 },
    // { col: 20, row: 13 },
    // { col: 21, row: 13 },
    // { col: 22, row: 13 },
    // { col: 23, row: 13 },
    // { col: 0, row: 14 },
    // { col: 1, row: 14 },
    // { col: 2, row: 14 },
    // { col: 3, row: 14 },
    // { col: 4, row: 14 },
    // { col: 5, row: 14 },
    // { col: 6, row: 14 },
    // { col: 7, row: 14 },
    // { col: 8, row: 14 },
    // { col: 9, row: 14 },
    // { col: 10, row: 14 },
    // { col: 11, row: 14 },
    // { col: 12, row: 14 },
    // { col: 13, row: 14 },
    // { col: 14, row: 14 },
    // { col: 15, row: 14 },
    // { col: 16, row: 14 },
    // { col: 17, row: 14 },
    // { col: 18, row: 14 },
    // { col: 19, row: 14 },
    // { col: 20, row: 14 },
    // { col: 21, row: 14 },
    // { col: 22, row: 14 },
    // { col: 23, row: 14 },
    // { col: 0, row: 15 },
    // { col: 1, row: 15 },
    // { col: 2, row: 15 },
    // { col: 3, row: 15 },
    // { col: 4, row: 15 },
    // { col: 5, row: 15 },
    // { col: 6, row: 15 },
    // { col: 7, row: 15 },
    // { col: 8, row: 15 },
    // { col: 9, row: 15 },
    // { col: 10, row: 15 },
    // { col: 11, row: 15 },
    // { col: 12, row: 15 },
    // { col: 13, row: 15 },
    // { col: 14, row: 15 },
    // { col: 15, row: 15 },
    // { col: 16, row: 15 },
    // { col: 17, row: 15 },
    // { col: 18, row: 15 },
    // { col: 19, row: 15 },
    // { col: 20, row: 15 },
    // { col: 21, row: 15 },
    // { col: 22, row: 15 },
    // { col: 23, row: 15 },
  ],
  isAlreadyUndo: false,
  showModal: false,
  prevErrorCode: null,
};
export default function tipStateReducer(state = initialState, action = '') {
  switch (action.type) {
    case ActionType.SET_TIP_AMOUNT:
      return {...state, amount: action.amount};
    case ActionType.SELECT_TIP_COLUMN:
      return {...state, selectedColumns: [...state.selectedColumns, action.column]};
    case ActionType.SELECT_TIP_QUADRANT:
      return {...state, selectedQuadrants: [...state.selectedQuadrants, action.quadrant]};
    case ActionType.SET_SELECTED_TIP_COLUMN:
      return {...state, selectedColumns: action.selectedColumns};
    case ActionType.SET_SELECTED_TIP_QUADRANT:
      return {...state, selectedQuadrants: action.selectedQuadrants};
    case ActionType.SET_SELECTED_TIP:
      return {...state, selectedTip: action.selectedTip};
    case ActionType.SET_PREV_SELECTED_TIP:
      return {...state, prevSelectedTip: action.prevSelectedTip};
    case ActionType.SET_IS_ALREADY_UNDO:
      return {...state, isAlreadyUndo: action.isAlreadyUndo};
    case ActionType.SET_TIP_STATE:
      return {
        ...state,
        selectedQuadrants: action.selectedQuadrants,
        selectedColumns: action.selectedColumns,
        selectedRows: action.selectedRows,
        amount: action.amount,
      };
    case ActionType.DESELECT_TIP_COLUMN:
      return {
        ...state,
        selectedColumns: [...state.selectedColumns.filter((elem, id) => id !== action.columnId)],
      };
    case ActionType.DESELECT_TIP_QUADRANT:
      return {
        ...state,
        selectedQuadrants: [...state.selectedQuadrants.filter((elem, id) => id !== action.quadrantId)],
      };
    case ActionType.RESET_TIP_SELECTION:
      return {...state, ...initialState};
    case ActionType.RESTORE_TIP_STATE: {
      return action.state;
    }
    case ActionType.SET_SHOW_SET_TIP_MODAL: {
      return {
        ...state,
        showModal: action.isShow,
      };
    }
    case ActionType.SET_PREV_ERROR_SET_TIP_MODAL: {
      return {
        ...state,
        prevErrorCode: action.errorCode,
      };
    }
    default:
      return state;
  }
}
